<template>
  <div class="sign-up-complete h-100 d-flex align-items-center justify-content-center">
    <main class="sign-up-complete__container mt-5 fs-14-regular">
      <b-row class="mx-auto m-0 p-0">
        <b-col cols="12" class="m-0 mb-1 p-0">
          <img src="../../assets/logo.svg" alt="logo" width="130" />
        </b-col>
        <b-col cols="12" class="m-0 mt-2 p-0">
          <h1 class="mb-2 fs-24-bold">送信完了</h1>
          <b-card class="mt-1">
            <p>ご入力いただいたメールアドレス( {{ mailAddress }} )宛に、</p>
            <p>お申込み手続きを続けるためのメールを送信させていただきました。</p>
            <p>引き続きそちらから手続きをお願いいたします。</p>
            <p>なお、ご登録いただいたメールアドレスが間違っていると、利用開始メールが届かない場合があります。</p>
            <p>お申込みから1時間以上経過しても、弊社からのメールが受信できない場合は、</p>
            <p class="m-0">恐れ入りますが以下の問い合わせ先までご連絡ください。</p>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mx-auto m-0 mt-3 p-0">
        <!-- <b-col cols="12" class="m-0 p-0 text-center">
          <img src="../../assets/tel1_tas.png" alt="e秘書専用相談窓口:0120-600-024">
        </b-col> -->
        <b-col cols="12" class="m-0 p-0">
          <div class="w-100 p-0 pl-1 pr-1 text-center">
            <p class="fs-4">ご不明な点がございましたら、下記窓口へお問い合わせください。</p>
            <div class="sign-up-complete__phone-info d-flex align-items-end justify-content-center">
              <div class="d-flex align-items-center">
                <img src="../../assets/tel1_tas_02.svg" alt="tel-tas" width="40">
                <u class="sign-up-complete__phone-number pl-2 fs-24-bold">0120-600-024</u>
              </div>
              <span>(全日9時〜21時)</span>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="m-0 mt-3 p-0">
          <p class="pt-2 text-center fs-12-regular text-info sign-up-complete__copyright">
            Copyright © Bellsystem24, Inc. All Rights Reserved
          </p>
        </b-col>
      </b-row>
    </main>
  </div>
</template>

<script>
export default {
  name: 'SignInCompleted',
  data () {
    return {
      mailAddress: ''
    }
  },
  created () {
    if (process.env.NODE_ENV === 'production') {
      // NOTE: Google Analytics（完了）
      this.$gtag.pageview({
        page_path: 'sign_up_completed',
        page_title: '申込ページ(ログインアカウント作成)：完了'
      })
      this.$gtag.event('conversion', {
        send_to: 'AW-370693557/GPPfCPGW6eYCELWr4bAB'
      })
    }
    this.mailAddress = sessionStorage.getItem('mypage_mail_address')
    sessionStorage.removeItem('mypage_mail_address')
  },
  mounted () {
    if (process.env.NODE_ENV === 'production') {
      // NOTE: Yextの計測タグを動的に追加する
      let scriptEl = document.createElement('script')
      scriptEl.setAttribute('type', 'text/javascript')
      scriptEl.innerHTML = 'window.ytagQ = window.ytagQ || []; function ytag() {window.ytagQ.push(arguments);} ytag("conversion", {"cid": "5e6e33c7-e1c2-49f1-b9fd-c34275158ab0"});'
      scriptEl.classList.add('addAdvertisementTag')
      document.body.appendChild(scriptEl)
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.sign-up-complete {
  &__container {
    padding: 1rem;
    width: 730px
  }

  &__copyright {
    border-top: 1px solid #CED2D5
  }

  &__phone-info {
    margin: auto;
    gap: 3rem;
  }
}

@media (max-width: 768px) {
  .sign-up-complete {
    &__container {
      width: 100%
    }

    &__phone-info {
      gap: 1rem;
    }

    &__phone-number {
      font-size: 1.25rem !important;
    }
  }
}
</style>
